/*! qrcanvas-react v2.0.2 | ISC License */
import _extends from '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import _inheritsLoose from '@babel/runtime/helpers/esm/inheritsLoose';
import { createElement, Component } from 'react';
import { qrcanvas } from 'qrcanvas';

var QRCanvas = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(QRCanvas, _React$Component);

  function QRCanvas() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.canvas = null;

    _this.onBind = function (canvas) {
      _this.canvas = canvas;
    };

    return _this;
  }

  var _proto = QRCanvas.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.update();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.update();
  };

  _proto.render = function render() {
    return /*#__PURE__*/createElement("canvas", {
      ref: this.onBind
    });
  };

  _proto.update = function update() {
    var options = this.props.options;

    if (this.canvas) {
      options = _extends({}, options, {
        canvas: this.canvas
      });
      if (!options.cellSize && !options.size) options.cellSize = 6;
      qrcanvas(options);
    }
  };

  return QRCanvas;
}(Component);

export { QRCanvas };
